import React, { Component } from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'

export default class Logo extends Component {
    constructor(props){
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        
        return (
            <div className="row" id="body">
                    
            <div className="col-12 mx-0 col-lg-10" id="content">

                <div className="row pt-4" id="ui_design">
                    <div className="col-12 col-md-4 col-sm-6">
                      <img id="logo0" width="100%" src={require('../../../Images/Daily_project/Logo/logo1.png')} alt="Case_studies_1" />
                    </div>
                    <div className="col-12 col-md-4 col-sm-6 pt-4 pt-sm-0">
                      <img id="logo1" width="100%" src={require('../../../Images/Daily_project/Logo/logo2.png')} alt="Case_studies_2" />
                    </div>
                    <div className="col-12 col-md-4 col-sm-6 pt-4 pt-sm-0">
                      <img id="logo1" width="100%" src={require('../../../Images/Daily_project/Logo/logo7.png')} alt="Case_studies_2" />
                    </div>
                    <div className="col-12 col-md-4 col-sm-6 pt-4 pt-md-0">
                      <img id="logo2" width="100%" src={require('../../../Images/Daily_project/Logo/logo3.png')} alt="Case_studies_2" />
                    </div>
                    <div className="col-12 col-md-4 col-sm-6 pt-4 pt-md-4">
                      <img id="logo3" width="100%" src={require('../../../Images/Daily_project/Logo/logo4.png')} alt="Case_studies_2" />
                    </div>
                    <div className="col-12 col-md-4 col-sm-6 pt-4 pt-md-4">
                      <img id="logo4" width="100%" src={require('../../../Images/Daily_project/Logo/logo5.png')} alt="Case_studies_2" />
                    </div>
                    <div className="col-12 col-md-4 col-sm-6 pt-4 pt-md-4">
                      <img id="logo5" width="100%" src={require('../../../Images/Daily_project/Logo/logo6.png')} alt="Case_studies_2" />
                    </div>
                </div>
            </div>
                    
            <div className="col-lg-2 d-none d-lg-block px-4 pt-4 h-25 sticky-top" id="sidebar" style={{top: "56px"}}>

                <p className="h4">Project</p>
                <p>
                  <AnchorLink href="#logo0" className="bullet">Letter mark</AnchorLink>
                  <br />
                  <AnchorLink href="#logo1" className="bullet">Combo mark</AnchorLink>
                  <br />
                  <AnchorLink href="#logo2" className="bullet">Moscot</AnchorLink>
                  <br />
                  <AnchorLink href="#logo3" className="bullet">Emblem</AnchorLink>
                  <br />
                  <AnchorLink href="#logo4" className="bullet">Word mark</AnchorLink>
                  <br />
                  <AnchorLink href="#logo5" className="bullet">Symbol logo</AnchorLink>
                </p>

                <div className="row pt-4 px-3">
                <p className="h4">TOOLS</p>

                <div className="col-12 px-2">
                  <div className="row">
                          <img width="25%" className="tools" src={require('../../../Images/Tools/ai.png')} alt="Case_studies_1" />
                  </div>
                </div>
                
              </div>

            </div>
                  
            </div>
    )
}
}